module.exports = __webpack_public_path__ + "media/img/android-icon-48x48-f8663f6e2084bf09609df6d22a51dad7.png";